// AUTO-GENERATED FILE. Do not edit.
import  { EvolutionTriggerName, PokeData } from "types/pokemon/poke-data";
import  { PokeType } from "types/pokemon/poke-type";

export const sharpedo: PokeData = {
  "id": 319,
  "name": "sharpedo",
  "height": 18,
  "weight": 888,
  "base_experience": 161,
  "types": [
    PokeType.WATER,
    PokeType.DARK
  ],
  "api_moves": [
    "take-down",
    "leer",
    "bite",
    "agility",
    "rage",
    "screech",
    "focus-energy",
    "skull-bash",
    "slash",
    "scary-face",
    "swagger",
    "crunch",
    "taunt",
    "poison-fang",
    "feint",
    "assurance",
    "night-slash",
    "ice-fang",
    "aqua-jet",
    "liquidation"
  ],
  "moves": [
    "leer",
    "bite",
    "scary-face",
    "crunch",
    "poison-fang",
    "night-slash",
    "ice-fang",
    "aqua-jet",
    "liquidation",
    "brine",
    "bubble",
    "life-dew",
    "water-spout"
  ],
  "evolution_chain": {
    "id": 160,
    "item": null,
    "species": [
      {
        "name": "carvanha",
        "order": 346,
        "types": [
          PokeType.WATER,
          PokeType.DARK
        ],
        "evolves_from_species_id": null,
        "pokemonevolutions": []
      },
      {
        "name": "sharpedo",
        "order": 347,
        "types": [
          PokeType.WATER,
          PokeType.DARK
        ],
        "evolves_from_species_id": 318,
        "pokemonevolutions": [
          {
            "type": null,
            "min_level": 30,
            "item": null,
            "location": null,
            "min_happiness": null,
            "min_affection": null,
            "min_beauty": null,
            "move": null,
            "relative_physical_stats": null,
            "time_of_day": "",
            "trade_species_id": null,
            "turn_upside_down": false,
            "held_item_name": null,
            "evolutiontrigger": {
              "name": EvolutionTriggerName.LEVEL_UP
            },
            "gender": null
          }
        ]
      }
    ]
  },
  "stats": {
    "resistance": 81,
    "speed": 141,
    "ability_power": 178
  },
  "stat_changes": [],
  "catch_rate": 60,
  "is_legendary": false,
  "is_mythical": false,
  "is_mega": false,
  "is_gmax": false,
  "regional_variant": null
} as const;
